import React, { useState, useEffect } from 'react'
import { PhoneOutlined, MailOutlined} from '@ant-design/icons';
import { Button, Flex, Avatar } from 'antd';
import { useNavigate } from "react-router-dom";

import LOGO from '../images/logomarca_CRQ.png'
import { primaryColor } from '../service/estilo'
import { isMobile } from 'react-device-detect';


export const OutletNoRegisterHome = (props) => {

    let navigate = useNavigate()

    return <Flex vertical>
        <Flex style={{ backgroundColor: primaryColor }}>
            <Flex
                style={{ paddingLeft: 25, paddingRight: 25, paddingTop: 10, paddingBottom: 10, width: '100%', fontSize: '0.7em', color: '#fff' }}
                justify='space-between'>
                <Flex gap={10} align='center' >
                    <Flex gap={5}>
                        <PhoneOutlined style={{ color: 'white' }} /> (85) 3226-4958 / 3253-1607
                    </Flex>
                    <Flex gap={5}>
                        <MailOutlined style={{ color: 'white' }} /> registroprofissional@crqx.org.br
                    </Flex>
                </Flex>

                  { isMobile === false &&  <Flex>
                    Seg-Sex: 8:30 às 12h e 13 às 17h
                </Flex>}
             
            </Flex>
        </Flex>
        <Flex style={{ padding: 10, color: primaryColor, paddingTop: 15, paddingBottom: 15 }} justify='space-between'>
            <Flex align='center' gap={10}>
                <Avatar size={60} src={LOGO} />
                <Flex vertical>
                    <Flex style={{ color: primaryColor, fontSize: '1.2em', fontFamily: 'Cambria, Times New Roman, Times, serif' }}><strong>CRQ10/CE</strong></Flex>
                    <Flex style={{ color: 'gray', fontSize: '0.7em' }}>Conselho Regional de Química</Flex>
                    <Flex style={{ color: 'gray', fontSize: '0.7em' }}>10ª Região - CE</Flex>
                </Flex>
            </Flex>
            <Flex align='center'>
                <Button type='primary' color='white' style={{ backgroundColor: 'green' }}
                    onClick={() => {
                        navigate("/login")
                    }}>Acessar</Button>
            </Flex>
        </Flex>

        <Flex style={{ padding: 20, backgroundColor: primaryColor, paddingTop: 35, paddingBottom: 35 }} vertical>
            <Flex style={{ fontSize: '1.6em', fontWeight: 'bold', color: '#fff' }}>
                Conselho Regional de Química da 10ª Região
            </Flex>
            <Flex style={{ color: 'gray' }}>
                Fiscalização e valorização do exercício profissional da Química no Ceará.
            </Flex>
            <Flex style={{ marginTop: 10 }}>

            </Flex>
        </Flex>
    </Flex>
}

export default OutletNoRegisterHome

